import {
  useController,
  type FieldValues,
  type UseControllerProps,
} from "react-hook-form";
import {
  CheckboxGroup,
  type ICheckboxGroupProps,
} from "@components/inputs/CheckboxGroup/CheckboxGroup";

type TFormCheckboxGroupProps<T extends FieldValues> = ICheckboxGroupProps &
  UseControllerProps<T>;

export const FormCheckboxGroup = <T extends FieldValues>({
  name,
  control,
  ...restProps
}: TFormCheckboxGroupProps<T>) => {
  const controller = useController({
    name,
    control,
  });

  const {
    field,
    fieldState: { error },
  } = controller;

  const { ref: fieldRef, ...fieldRest } = field;

  return (
    <CheckboxGroup
      {...restProps}
      {...fieldRest}
      inputRef={fieldRef}
      error={error?.message}
      {...(restProps.disabled ? { disabled: true } : {})}
      onChange={(value) => {
        fieldRest.onChange(value);
        restProps.onChange?.(value);
      }}
    />
  );
};
